import { Expose } from "class-transformer";
import { IsEnum, IsNumber, IsOptional, IsString } from "class-validator";
import { OWNER_TYPES } from "@/static/ownerTypes";

export class OwnerTemporary {
  @IsOptional()
  @IsNumber()
  @Expose()
  id!: null | number;
  @IsNumber()
  @Expose()
  share!: number;
  @IsEnum(OWNER_TYPES)
  @Expose()
  ownerType!: OWNER_TYPES;
  @IsString()
  @Expose()
  name!: string;
}

export type OrderOwners = Array<OwnerTemporary>;
